const DEFAULT_BASE_URL = "https://admin.tripit.cc/api/thirdservice";

function normalizeBaseUrl(value) {
  return (value || DEFAULT_BASE_URL).replace(/\/+$/, "");
}

async function readResponse(response) {
  const text = await response.text();
  let payload = null;

  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    throw new Error("上游返回了无法解析的响应（HTTP " + response.status + "）");
  }

  if (!response.ok) {
    const upstreamError = payload && payload.error;
    const message = (upstreamError && upstreamError.message) || payload?.message || "HTTP " + response.status;
    const error = new Error(message);
    if (upstreamError && upstreamError.code) error.code = upstreamError.code;
    error.status = response.status;
    throw error;
  }

  if (payload && payload.code && payload.code !== 20000) {
    throw new Error(payload.msg || payload.message || "上游业务请求失败（code: " + payload.code + "）");
  }

  return payload;
}

/**
 * Creates a client for the Tripit open API described in 对外开放API文档.pdf.
 * Credentials are kept by the caller and the access token is cached in memory only.
 */
export function createTripitClient({ baseUrl, username, password, fetchImpl = fetch } = {}) {
  const endpoint = normalizeBaseUrl(baseUrl);
  let accessToken = "";

  async function authenticate() {
    if (!username || !password) throw new Error("请先配置 Tripit 用户名和密码");

    const response = await fetchImpl(endpoint + "/token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });
    const payload = await readResponse(response);
    if (!payload?.access_token) throw new Error("上游认证响应缺少 access_token");
    accessToken = payload.access_token;
    return accessToken;
  }

  async function post(path, body, retry = true) {
    if (!accessToken) await authenticate();

    const response = await fetchImpl(endpoint + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      body: JSON.stringify(body),
    });

    if (response.status === 401 && retry) {
      accessToken = "";
      return post(path, body, false);
    }

    return readResponse(response);
  }

  return {
    authenticate,
    getData(params = {}) {
      return post("/data", {
        product: "url",
        page: 1,
        limit: 50,
        ...params,
      });
    },
    getAdunit(params = {}) {
      return post("/adunit", {
        product: "url",
        countryCode: "",
        adunit: "",
        page: 1,
        limit: 50,
        ...params,
      });
    },
  };
}

export function fetchTripitData(config, params) {
  return createTripitClient(config).getData(params);
}

export function fetchTripitAdunit(config, params) {
  return createTripitClient(config).getAdunit(params);
}

export { DEFAULT_BASE_URL as TRIPIT_API_BASE_URL };
